/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ManualDisableYieldForSponsoredAccountsRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {ManualDisableYieldForSponsoredAccountsResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const manualDisableYieldForSponsoredAccounts = (request: ManualDisableYieldForSponsoredAccountsRequest, options?: CashRequestOptions) => post<ManualDisableYieldForSponsoredAccountsRequest, ManualDisableYieldForSponsoredAccountsResponse>("/2.0/cash/manual-disable-yield-for-sponsored-accounts", request, {...options, rejectOnError: true })